import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ProgramListItem } from './ProgramListItem';
import { AppServices } from 'services/AppServices';
import { Spinner } from '../common/Spinner';
import Locale from 'localization/Localization';
import { Layout } from 'components/common/Layout';

interface ProgramListPageState {
	programDownloadFinished: boolean;
}

export class ProgramListPage extends React.Component<RouteComponentProps<{}>, ProgramListPageState>
{
	constructor(props: RouteComponentProps<{}>) {
		super(props);

		if (AppServices.programService.programs !== undefined) {
			this.state = {
				programDownloadFinished: true
			}
		}
		else {
			this.state = {
				programDownloadFinished: false
			}
		}
	}

	public componentDidMount() {
		if (this.state.programDownloadFinished === false) {
			AppServices.programService.getUserPrograms().then(() => {
				this.setState({
					programDownloadFinished: true
				})
			}).catch(reason => {
				console.error(reason);
				this.setState({
					programDownloadFinished: true
				})
			});
		}

		document.title = Locale.getPageTitle("page_programs");
	}

	public render() {
		let content: JSX.Element;
		if (this.state.programDownloadFinished) {
			const programs = AppServices.programService.programs;

			if (programs !== undefined) {
				if (programs.length > 0) {
					content = <React.Fragment>
						{programs.map((program) =>
							<ProgramListItem key={program.guid} program={program} />
						)}
					</React.Fragment>;
				}
				else {
					content = (
						<div>{Locale.get("programs_listEmpty")}</div>
					);
				}
			}
			else {
				content = (
					<div>{Locale.get("programs_loadError")}</div>
				);
			}

		}
		else {
			content = <Spinner />;
		}

		return <Layout>
			<div className='program-list'>
				<h1>{Locale.get("programs_title")}</h1>
				{content}
			</div>
		</Layout>;
	}
}